import { FC } from 'react';

interface GCoinIconProps {
  isLastCard: boolean;
}

export const GCoinIcon: FC<GCoinIconProps> = ({ isLastCard }) => {
  return (
    <svg
      width="27"
      height="25"
      viewBox="0 0 27 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={isLastCard ? { opacity: 0.5 } : {}}
    >
      <g filter="url(#filter0_dd_787_7243)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.0399 24.73C19.6673 24.73 25.0399 19.3574 25.0399 12.73C25.0399 6.10256 19.6673 0.72998 13.0399 0.72998C6.4125 0.72998 1.03992 6.10256 1.03992 12.73C1.03992 19.3574 6.4125 24.73 13.0399 24.73ZM14.5399 5.23314V3.72998L11.5399 3.72998V5.23374C10.381 5.27167 9.47697 5.59701 8.82785 6.20976C8.13589 6.86295 7.78992 7.80385 7.78992 9.03247L7.78992 16.4275C7.78992 17.6561 8.13589 18.597 8.82785 19.2502C9.47697 19.863 10.381 20.1883 11.5399 20.2262V21.7304H14.5399V20.2269C15.6948 20.1923 16.5989 19.8667 17.252 19.2502C17.9439 18.5815 18.2899 17.6406 18.2899 16.4275L18.2899 12.5317C18.2899 12.174 18.1049 11.9951 17.7347 11.9951H13.5106C13.1727 11.9951 13.0037 12.1584 13.0037 12.485V14.0713C13.0037 14.3979 13.1727 14.5612 13.5106 14.5612H14.9589C15.1359 14.5612 15.2244 14.6468 15.2244 14.8179V16.2875C15.2244 16.7852 15.1198 17.1429 14.9106 17.3606C14.7014 17.5628 14.3393 17.6639 13.8244 17.6639H12.2554C11.7566 17.6639 11.3945 17.5628 11.1692 17.3606C10.96 17.1429 10.8554 16.7852 10.8554 16.2875V9.17244C10.8554 8.67477 10.96 8.32485 11.1692 8.12267C11.3945 7.90494 11.7566 7.79608 12.2554 7.79608H13.8244C14.3393 7.79608 14.7014 7.90494 14.9106 8.12267C15.1198 8.32485 15.2244 8.67477 15.2244 9.17244V9.73231C15.2244 10.0745 15.3934 10.2455 15.7313 10.2455H17.783C18.121 10.2455 18.2899 10.0745 18.2899 9.73231V9.03247C18.2899 7.8194 17.9439 6.88628 17.252 6.23309C16.5989 5.60187 15.6948 5.26856 14.5399 5.23314Z"
          fill={isLastCard ? "#777777" : "black"}
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_787_7243"
          x="0.039917"
          y="0.72998"
          width="26"
          height="24"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.988235 0 0 0 0 0 0 0 0 0 0.266667 0 0 0 0.56 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_787_7243"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.996078 0 0 0 0.988235 0 0 0 0.64 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_787_7243"
            result="effect2_dropShadow_787_7243"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_787_7243"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}; 